import { Link, useLocation } from 'react-router-dom';
import classNames from './sideBarItem.module.scss'
type SideBarItemProps = {
  title: string;
  icon: any;
  forward: any;
  onClose?: () => void;
  collapsed?: boolean;
}

export default function SideBarItem(props: SideBarItemProps) {
  const { title, icon, forward, onClose, collapsed } = props;
  const { pathname } = useLocation();
  const isActive = pathname.includes(forward);
  return (
    <Link
      to={forward}
      className={`${classNames.container} ${isActive ? classNames["--isactive"] : ""} ${collapsed ? classNames.collapsed : ""}`}
      onClick={onClose}
      aria-current={isActive ? 'page' : undefined}
      // The label is hidden while collapsed, so the native tooltip carries it instead.
      title={collapsed ? title : undefined}
      aria-label={collapsed ? title : undefined}
    >
      <span className={classNames.icon}>{icon}</span>
      <span className={classNames.text}>{title}</span>
    </Link>
  )
}
